{
  "404": {
    "text": {
      "1": "このページは存在しません。",
      "2": "Tap/click on a screen to continue",
      "3": "リダイレクトしています..."
    }
  },
  "about-me": {
    "title": "自己紹介",
    "list": [
      { "title": "{{totalExperience}}の商用ソフトウェア開発。" },
      { "title": "チームを管理した経験。" },
      { "title": "機能やプロジェクトのリード。" },
      { "title": "ソフトウェアアーキテクチャの設計。" },
      { "title": "機能の実装計画と納期内での提供。" },
      { "title": "技術面およびマネージャー面接の実施。" },
      { "title": "複数のチームや部門と連携し、開発要素を統合した経験。" },
      { "title": "ジュニアメンバーへの指導および教育経験。" },
      { "title": "バックエンド、フロントエンド、インフラ、CI/CD開発における豊富な知識と経験。" },
      { "title": "Java、TypeScript、Go、GitHub Actions、DevSecOps、アプリケーションセキュリティにおける強力な実績。" },
      { "title": "顧客向けおよび社内向けドキュメントの作成。" },
      { "title": "技術記事の公開。" },
      {
        "title": "オープンソースコミュニティへの参加：",
        "list": [
          { "title": "プルリクエスト作成やオープンソースプロジェクトへのチケット提出。" },
          { "title": "GitHub Actionsを35以上開発・リリースし、マーケットプレイスで公開。" },
          { "title": "StackOverflowやLeetCodeディスカッションへの積極的参加。" }
        ]
      }
    ]
  },
  "author": {
    "full-name": "ファビジェブスキーイェブヘン",
    "given-name": "イェブヘン",
    "job-title": "シニアソフトウェアエンジニア"
  },
  "badges": {
    "title": "バッジ"
  },
  "by-issuer": "{{issuer}}から",
  "certificates": {
    "title": "資格",
    "list": {
      "MWE43H8YDS": "みんなのためのプログラミング（Python）",
      "W5AB2PBZQNPY": "Javaにおける並列・並行・分散プログラミング専門講座",
      "UC-JGDVYKAQ": "React完全開発者コース（HooksとRedux付き）",
      "689b9d7e-cae5-4e36-8a1f-c8c34f104249": "Oracle Certified Associate, Java SE 8 Programmer",
      "F75CDD8ED9F0": "問題解決（基礎）",
      "24722d5e-1738-4cec-808b-b4b83a94a8ad": "GitHub Advanced Security",
      "711c8e30-13e7-499e-aad6-5da9d468177a": "GitHub Actions",
      "6f36f952-612a-4aa1-8a3d-adb29396c967": "GitHub Foundations",
      "a1c1ec77-29db-4139-8fcb-ac95408653e8": "GitHub Administration",
      "9f12275d-a5b5-4d4d-9127-c975c555f0ab": "認定DevSecOpsプロフェッショナル（CDP）",
      "55ddd8bd-950d-45bb-ad25-d08269bc9ca1": "GitHub Copilot",
      "517b6607-def7-46e1-b007-493a15b5eeb2": "Terraform Associate (003)"
    }
  },
  "comma": "、",
  "contacts": {
    "title": "連絡先",
    "location": "日本東京都"
  },
  "education": {
    "title": "学歴",
    "university": {
      "osar": {
        "speciality": "情報科学技術。修士号。",
        "title": "オデッサ国立冷凍学アカデミー"
      }
    }
  },
  "experience": {
    "present": "現在",
    "title": "職歴",
    "tech-stack": "技術",
    "achievements": "実績",
    "body": {
      "woven-by-toyota": [
        "コードスキャン、SCA、SBOM分析を実行するための３つの主要なアプリケーションセキュリティ用GitHub Actionsを作成しました。これらは社内全体で広く使用されており、現在、１日に１０００回以上呼び出されています。",
        "私が設計した認証・認可システムは、部門全体（１１チーム）のコアシステムとして使用されています。",
        "６人のエンジニアからなるチームを構築しました。候補者の選考、採用プロセス、メンタリング、そして個人の成長支援を含みます。",
        "チームのセキュリティチャンピオンとして、５０以上のリポジトリ（フロントエンド、バックエンド、IaCなど）にアプリケーションセキュリティのベストプラクティスを設定しました。",
        "バックエンドの認証・認可システムとしてKeycloakを構成しました。",
        "Go言語でのバックエンドプロジェクトをエンドツーエンドでリードしています。"
      ],
      "bitcoin-com": [
        "Javaのバックエンドプロジェクトにおいて、単体テストのコードカバレッジを０％から８０％に向上させました。",
        "レガシーなAndroidアプリケーションを復元し、最新バージョンにアップグレードしました。デザインを一新し、追加機能を実装して新しいリリースを公開しました。",
        "バックエンドアプリケーションのためにTravis CIをゼロから構成しました。",
        "レガシーなAndroidアプリケーションのためにBitriseをゼロから構成しました。",
        "ウェブアプリケーションのためにGitHub Actionsをゼロから構成しました。"
      ],
      "lohika": "Lohikaはアウトソーシング会社であり、私はオフショア契約者としてさまざまな企業、主にHewlett Packard Enterpriseの業務に従事していました。RIA、バックエンド、モバイル、およびさまざまなウェブアプリケーションを開発しました。",
      "arka": "投資アプリケーションを社内プロジェクトとして開発。また、主にドイツの外部顧客向けのさまざまなウェブアプリケーションを開発。"
    }
  },
  "header": {
    "occupation": "シニアソフトウェアエンジニア",
    "title": "<p>{{authorGivenName}}です。</p><p>よろしくお願いいたします。</p>"
  },
  "languages": {
    "title": "言語",
    "fluent": "流暢",
    "native": "母国語",
    "codes": {
      "gb": "英語",
      "jp": "日本語",
      "ru": "ロシア語",
      "ua": "ウクライナ語"
    }
  },
  "locations": {
    "odesa": "ウクライナ・オデサ",
    "chuo": "日本東京都中央区",
    "shibuya": "日本東京都渋谷区"
  },
  "month": ["一月", "二月", "三月", "四月", "五月", "六月", "七月", "八月", "九月", "十月", "十一月", "十二月"],
  "resume": {
    "title": "履歴書",
    "body": "私の履歴書をダウンロードするには、<1>LinkedInページ</1>にアクセスし、「リソース」→「PDFとして保存」を選択してください。"
  },
  "skills": {
    "title": "スキル"
  },
  "stats": {
    "title": "データ"
  },
  "themes": {
    "light": "光",
    "dark": "闇"
  },
  "title": "{{authorFullName}} :: {{authorJobTitle}}",
  "version": "バージョン{{version}}",
  "year": "年"
}
